import { createSelector } from "reselect";
import { getLandingPageFormValues } from "../../data/landingPageForm/selectors";

// ===============================================
// ============= STATE GETTERS ===================
// ===============================================
// const getLandingPageFormValues = (state) => state.landingPage
// const isRoundTrip = state => state.landingPage.isRoundTrip;
const getNumberOfETickets = state => {
  if (state.trips.installmentInfo) {
    return state.trips.installmentInfo.numberOfETickets;
  }
};
const getTripFinancials = state => {
  // installmentInfo is arbitrarily selected. If it exits, trips should be ready.
  // Without check, attempting access empty state (i.e. page refresh on /review-order)
  // would yield error.
  if (state.trips.installmentInfo) {
    const { ppnBookBundle, ...tripFinancials } = state.trips.installmentInfo; // Removing ppnBookBundle from obj
    return tripFinancials;
  }
};
const getSelectedDepartingTrip = state => {
  if (state.trips.installmentInfo) {
    const { selectedDepartingTripId, departingTrips } = state.trips;
    return departingTrips.find(trip => trip.id === selectedDepartingTripId);
  }
};
const getSelectedReturningTrip = state => {
  const { selectedReturningTripId, returningTrips } = state.trips;
  // return isRoundTrip(state) && returningTrips.find(trip => trip.id === selectedReturningTripId);
  return (
    returningTrips &&
    returningTrips.find(trip => trip.id === selectedReturningTripId)
  );
};
// const getDepartureDate = state => state.landingPage.depart_date;

// ===============================================
// ============= SELECTORS =======================
// ===============================================

// Selected trip, formatted for submission to fwdlook db
export const getSelectedTrip = createSelector(
  [
    getLandingPageFormValues,
    getTripFinancials,
    getSelectedDepartingTrip,
    getSelectedReturningTrip,
    getNumberOfETickets
    // isRoundTrip
  ],
  // (landingPageFormValues, tripFinancials, departing, returning, isRoundTrip) => {
  (
    landingPageFormValues,
    tripFinancials,
    departing,
    returning,
    numberOfETickets
  ) => {
    // Check just so /review-order doesn't crash if no state exists, when user hits route directly
    if (departing) {
      const tripInfo = {
        // to: landingPageFormValues.user_entered_location_to,
        // from: landingPageFormValues.user_entered_location_from,
        // cabin: landingPageFormValues.preferredCabin,
        // departDate: landingPageFormValues.depart_date,
        // returnDate: landingPageFormValues.return_date,

        ...landingPageFormValues,
        numberOfETickets,

        // to: 'Chitown',
        // from: 'Lag',
        // cabin: 'Econ',
        // departDate: '1990-20-31',
        // returnDate: '1990-20-30',
        // isRoundTrip: true,

        departing,
        returning
        // isRoundTrip
      };

      // console.log('somto selector tripInfo', tripInfo)
      return {
        tripInfo,
        tripFinancials
      };
    }
  }
);



// WEBPACK FOOTER //
// ./src/data/trips/selectors.js